import { DefaultService } from "@/services/DefaultService";

export default class GrupoComissaoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    findAll(column, order, page, limit, situacao, ...params) {
        return this._http
            .get(
                `${
                    this._env
                }/vendas/grupocomissao.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error("Problems while jobs are loading");
                }
            );
    }

    updateSituacao(grupocomissao) {
        return this._http
            .post(
                `${this._env}/vendas/grupocomissao/updatesituacao`,
                grupocomissao,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error("Problems while jobs are loading");
                }
            );
    }

    save(grupocomissao) {
        return this._http
            .post(
                `${this._env}/vendas/grupocomissao`,
                grupocomissao,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    find(id) {
        return this._http
            .get(`${this._env}/vendas/grupocomissao/${id}.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error("Problems while jobs are loading");
                }
            );
    }

    findAllCombo(...params) {
        return this._http
            .get(
                `${
                    this._env
                }/vendas/grupocomissao/getcombo.json?param=${params}`,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error("Problems while jobs are loading");
                }
            );
    }
}
